import { render, staticRenderFns } from "./loan-information.vue?vue&type=template&id=6b821410&"
import script from "./loan-information.vue?vue&type=script&lang=js&"
export * from "./loan-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports